<template>
  <div class="export-buttons">
    <b-button
      class="export-button"
      variant="success"
      aria-label="Export to Excel"
      @click="$emit('export', 'xlsx')"
    >
      <i class="fa fa-file-excel-o mr-2" />
      {{ $t('PQTOffersView.excelXar') }}
    </b-button>
    <b-button
      class="export-button"
      variant="danger"

      aria-label="Export to PDF"
      @click="$emit('export', 'pdf')"
    >
      <i class="fa fa-file-pdf-o mr-2" />
      {{ $t('PQTOffersView.pdfXar') }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: "ExportButtons"
};
</script>

<style scoped>
.export-buttons {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  justify-content: center;
}

.export-button {
  width: 160px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  margin: 0 10px;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.export-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive styles */
@media (max-width: 576px) {
  .export-buttons {
    flex-direction: column;
    align-items: center;
  }

  .export-button {
    width: 90%;
    margin: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
